import React from 'react';
import CommentCard from './CommentCard';

function CommentList({ comments }) {
  if (!comments?.length) {
    return (
      <div className="p-3 text-sm text-gray-500 text-left">No comments yet.</div>
    );
  }

  return (
    <ul className="space-y-2 p-3 list-none m-0">
      {comments.map((comment) => (
        <li key={comment.id}>
          <CommentCard comment={comment} />
        </li>
      ))}
    </ul>
  );
}

export default CommentList;
